export default "__VITE_ASSET__D55U1yVw__"